import { sortBy } from 'lodash';
import React from 'react';
import Button from '~/src/components/Button';
import ContentContainer from '~/src/components/ContentContainer';
import styles from '~/src/lib/styles.json';
import { OtePlayer } from '~/src/models/OtePlayer';
import { OteSeasonsOtePlayer } from '~/src/models/OteSeasonOtePlayer';
import { OteTeam } from '~/src/models/OteTeam';
import { colorFromInt } from '~/src/overtime-lib/src/www/lib';
import './Seasons.scss';

const Season = ({ season, team }: { season: OteSeasonsOtePlayer; team?: OteTeam }) => {
	const Statistic = ({ value, label, isFloat = true }: { value: number; label: string; isFloat?: boolean }) => (
		<div className="Statistic">
			<label style={{ color: colorFromInt(team?.secondary_foreground_color) }}>{label}</label>
			<div className="Value">{isFloat ? (value ?? 0).toFixed(1) : value ?? 0}</div>
		</div>
	);
	const perSuffix = season.ote_season.is_per_40 ? '40' : 'game';

	return (
		<div
			className="Season"
			style={{
				backgroundColor: team?.is_current ? colorFromInt(team.secondary_color) : styles.COLOR.BLACK,
			}}
		>
			<div className="Name">{season.ote_season.name}</div>
			<div className="Statistics">
				{/* <Statistic label="Total points" value={season.points} isFloat={false} /> */}
				<Statistic label={`Points Per ${perSuffix}`} value={season[`points_per_${perSuffix}`]} />
				<div className="Rule" />
				<Statistic label={`Rebounds Per ${perSuffix}`} value={season[`rebounds_per_${perSuffix}`]} />
				<div className="VRule" />
				<Statistic label={`Assists Per ${perSuffix}`} value={season[`assists_per_${perSuffix}`]} />
				<div className="Rule" />
				<Statistic label={`Steals Per ${perSuffix}`} value={season[`steals_per_${perSuffix}`]} />
				<div className="VRule" />
				<Statistic label={`Blocks Per ${perSuffix}`} value={season[`blocks_per_${perSuffix}`]} />
			</div>
			{!season.ote_season.is_per_40 && season.ote_season.should_show_for_players ? (
				<div className="MoreContainer">
					<Button
						style={{
							background: team?.is_current ? colorFromInt(team.primary_color) : styles.COLOR.WHITE,
							color: team?.is_current ? colorFromInt(team.foreground_color) : styles.COLOR.BLACK,
						}}
						href={`/players/${season.ote_player_id}/seasons/${season.ote_season_id}`}
					>
						Per Game Stats
					</Button>
				</div>
			) : null}
		</div>
	);
};

const Seasons = ({ player, team }: { player: OtePlayer; team: OteTeam }) => {
	const seasons = player.ote_seasons_ote_players?.filter((s) => s.ote_season.should_show_for_players && s.minutes > 0);
	if (seasons.length === 0) {
		return <></>;
	}
	return (
		<div className="PlayerSeasons">
			<ContentContainer>
				<div className="SeasonsContainer">
					{sortBy(seasons, 'updated_at')
						.reverse()
						.map((s) => (
							<Season key={s.id} season={s} team={team} />
						))}
				</div>
			</ContentContainer>
		</div>
	);
};
export default Seasons;
